import ProgressBar from "../../../../componentsNew/ProgressBar";
import Typography from "../../../../componentsNew/Typography";
import IconStatus from "../CardDashGrafico/IconStatus";


export default function ItemTabelaVisaoGeral({ titulo, valor, component = "string" }) {
    const renderizarComponent = () => {
        switch (component) {
            case "string":
                return <Typography component="body1" className="py-2">{valor || "-"}</Typography>
            case "progressBar":
                return <div className="w-4/6 flex py-2">
                    <div className="w-5/6 flex items-center mr-2">
                        <ProgressBar nota={valor?.toFixed(0) / 100} pequeno />
                    </div>
                    {valor?.toFixed(1)}
                </div>
            case "icon":
                return <div className="flex items-center">
                    <IconStatus mudancaPorcentagem={valor} />
                    <Typography component="body1" className="ml-2">{valor > 0 && "+"}{valor?.toFixed(2)}%</Typography>
                </div>
            default:
                return <></>
        }
    }
    return (
        <div className="w-3/12">
            <Typography component="body1-modal" className="uppercase py-2">{titulo}</Typography>
            {renderizarComponent()}
        </div>
    )


}
